import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";

import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";

import { SharedModule } from "@royalty/module";
import { RoyaltyButtonModule } from "@royalty/button";
import { AuthService } from "@royalty/service/api";

import { LoginDialogComponent } from "./login.dialog.component";
import { DirectiveModule } from "src/app/core/directive/directive.module";

@NgModule({
	declarations: [LoginDialogComponent],
	providers: [AuthService],
	imports: [
		MatButtonModule,
		MatDialogModule,
		MatInputModule,
		SharedModule,
		RoyaltyButtonModule,
		DirectiveModule
	],
	entryComponents: [LoginDialogComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LoginDialogModule {}
